import React from "react";
import PdfViewer from "../../PdfViewer";

const EstructuraOperativa = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/organigrama-operacional.pdf`;
  /*const pdfUrl = "/pdf/organigrama-operacional.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Organigrama Operacional</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default EstructuraOperativa;
